var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c("h1", { staticClass: "match-header" }, [
        _vm._v("Send " + _vm._s(_vm.email.name))
      ]),
      _vm._v(" "),
      _c(
        "md-card",
        [
          _c(
            "md-card-content",
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _vm._v(
                      "\n\t\t\t\t\tSubject: " +
                        _vm._s(_vm.email.subject) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    [
                      _c(
                        "md-tabs",
                        [
                          _c(
                            "md-tab",
                            { attrs: { id: "tab-html", "md-label": "HTML" } },
                            [
                              _c("div", { attrs: { id: "previewHTML" } }, [
                                _vm._v("HTML preview...")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-tab",
                            { attrs: { id: "tab-text", "md-label": "Text" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-preview",
                                  attrs: { id: "previewText" }
                                },
                                [_vm._v("Text preview...")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-tab",
                            {
                              attrs: {
                                id: "tab-attachments",
                                "md-label": "Attachments"
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { id: "previewAttachments" } },
                                [_c("i", [_vm._v("(none)")])]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _vm._v("\n\t\t\t\t\tMatched Advisors\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    { staticClass: "scrollable" },
                    [
                      _c(
                        "matched-advisors",
                        {
                          attrs: { advisors: _vm.advisors, ask: _vm.ask },
                          on: { changed: _vm.updateSelected }
                        },
                        [_vm._v("Advisors goes here...")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-interaction-button",
                {
                  attrs: { interaction: _vm.action },
                  on: { interact: _vm.doInteraction }
                },
                [_vm._v(_vm._s(_vm.action))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ask-feedback", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Feedback goes here...")
      ]),
      _vm._v(" "),
      _c(
        "comments",
        { staticClass: "mt-30", attrs: { ask: _vm.ask, section: "Comments" } },
        [_vm._v("Activity log goes here...")]
      ),
      _vm._v(" "),
      _c("activity-log", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Activity log goes here...")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d9b585e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d9b585e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractSendEmail.vue
// module id = null
// module chunks = 